import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export { default as Avatar } from './Avatar.vue'
export { default as AvatarBadge } from './AvatarBadge.vue'
export { default as AvatarFallback } from './AvatarFallback.vue'
export { default as AvatarGroup } from './AvatarGroup.vue'
export { default as AvatarGroupCount } from './AvatarGroupCount.vue'
export { default as AvatarImage } from './AvatarImage.vue'
export { default as AvatarWithFallback } from './AvatarWithFallback.vue'

export const avatarVariants = cva(
  'size-8 data-[size=lg]:size-10 data-[size=sm]:size-6 group/avatar relative flex shrink-0 select-none after:absolute after:inset-0 after:border after:border-border after:mix-blend-darken dark:after:mix-blend-lighten',
  {
    variants: {
      size: {
        sm: '',
        default: '',
        lg: '',
      },
      shape: {
        circle: 'rounded-full after:rounded-full',
        rounded: 'rounded-xl after:rounded-xl',
      },
    },
    defaultVariants: {
      size: 'default',
      shape: 'circle',
    },
  },
)

export type AvatarVariants = VariantProps<typeof avatarVariants>
